import React, { ReactElement } from 'react';
import { ApolloClient, ApolloProvider, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

import { ThemeProvider, CssBaseline } from '@material-ui/core';

import { ErrorBoundary } from './components/ErrorBoundary/ErrorBoundary';
import { getUri } from './utils/uri';
import { StoreProvider } from './store/store';
import Themes from './themes';
import Routes from './Routes';
import { AuthService } from './services/Auth/AuthService';
import PermissionsProvider from './store/permissions.context';

const uri = getUri(window.location.hostname);
const httpLink = createHttpLink({
  uri,
});

const authLink = setContext((_, { headers }) => {
  const token = AuthService.getToken();

  return {
    headers: {
      ...headers,
      ...(token && { authorization: `Bearer ${token}` }),
      system: 'Content',
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

export default function App(): ReactElement {
  return (
    <ThemeProvider theme={Themes.default}>
      <ApolloProvider client={client}>
        <StoreProvider>
          <ErrorBoundary>
            <PermissionsProvider>
              <CssBaseline />
              <Routes />
            </PermissionsProvider>
          </ErrorBoundary>
        </StoreProvider>
      </ApolloProvider>
    </ThemeProvider>
  );
}
